<script>
import { mapGetters, mapActions } from "vuex";

import { api as appApi } from "@/store/modules/app";
import { api as auditApi } from "@/store/modules/audits";
import { uploadFile } from "@/utils/uploader";

export default {
  data: () => ({
    uploadAvatarHandle: false
  }),
  computed: {
    ...mapGetters(auditApi.namespace, [
      // auditApi.getters.getAuditId,
      auditApi.getters.getAuditItemId,
      auditApi.getters.getDeviationId
    ])
  },
  methods: {
    ...mapActions(appApi.namespace, [appApi.actions.setLoading]),

    onFilePickedCached(e) {
      // set Loading:
      this.setLoading(true);

      const files = e.target.files;
      if (files[0] !== undefined) {
        const fileName = Date.now().toString() + "-" + files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          const imageFile = files[0]; // this is an image file that can be sent to server...

          console.log(imageFile);
          console.log(fr.result);

          this.uploadAvatarHandle = { url: fr.result, file: imageFile };
        });
      }

      this.setLoading(false);
    },
    onFilePicked(e) {
      // set Loading:

      this.setLoading(true);

      const files = e.target.files;

      if (files[0] !== undefined) {
        const imageFile = files[0]; // this is an image file that can be sent to server...
        console.log("FileUploader:0", imageFile);
        uploadFile(imageFile, {
          auditId: this.getAuditItemId,
          auditItemId: this.getAuditItemId,
          findingId: this.getDeviationId
        })
          .then(uploadSnapshot => {
            console.log("FileUploader:1", uploadSnapshot);
            return uploadSnapshot.ref.getDownloadURL();
          })
          .then(downloadUrl => {
            const payload = {
              audit_id: this.getAuditId,
              audititem_id: this.getAuditItemId,
              deviation_id: this.getDeviationId,
              data: { url: downloadUrl }
            };
            console.log("FileUploader:2", payload);

            console.log(payload);

            return this.attachFileToFinding(payload);
          })
          .then(() => {
            this.setLoading(false);
          })
          .catch(error => {
            console.error("FileUploader:3", error);
            this.setLoading(false);
          });
      }
    }
  }
};
</script>
